module.exports = __webpack_public_path__ + "static/BobbyChadha@2x-4a12b74d694135ef717db28bdb21c579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/avatars/BobbyChadha@2x.jpg
// module id = 2506
// module chunks = 157636680307020